import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconChartBars20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconChartBars20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M16.5 14.25V2.75a.75.75 0 0 0-1.5 0v11.5a.75.75 0 0 0 1.5 0M9.75 15a.75.75 0 0 1-.75-.75v-9a.75.75 0 0 1 1.5 0v9a.75.75 0 0 1-.75.75M3 14.25a.75.75 0 0 0 1.5 0v-4a.75.75 0 0 0-1.5 0zM2 16.5A.75.75 0 0 0 2 18h16a.75.75 0 0 0 0-1.5zM12.75 15a.75.75 0 0 1-.75-.75v-6.5a.75.75 0 0 1 1.5 0v6.5a.75.75 0 0 1-.75.75M6 14.25a.75.75 0 0 0 1.5 0v-2a.75.75 0 0 0-1.5 0z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconChartBars20);
